const {
  REACT_APP_PREFIX_ENVIRONMENT_FRONT_SERVICES = '',
  REACT_APP_FRONT_SUBSCRIPTION: REACT_APP_FRONT_SUBSCRIPTION_RAW = '',
  REACT_APP_ENV = 'production',
  PUBLIC_URL = ''
} = process.env

// El valor viene codificado en Base64 en las variables de entorno (ver docs/README_ENV_ENCODING.md)
const REACT_APP_FRONT_SUBSCRIPTION = REACT_APP_FRONT_SUBSCRIPTION_RAW
  ? atob(REACT_APP_FRONT_SUBSCRIPTION_RAW)
  : ''

// Configuración para Ciclos de Facturación
// =====================================================
// Número máximo de elementos a consultar en listas relacionadas con ciclos de facturación
const INVOICE_CYCLE_MAX_QUERY_ITEMS = 1000
// Tiempo de espera entre cada comprobación del estado del ciclo (en milisegundos)
const INVOICE_CYCLE_POLLING_DELAY = 5000
// Número máximo de intentos antes de pausar el polling automático
const INVOICE_CYCLE_POLLING_MAX_RETRIES = 10
// =====================================================

// Configuración para Instancias de Componentes de Precio
// =====================================================
// Umbral de instancias a partir del cual se cambia el comportamiento de carga
const PRICE_COMPONENT_INSTANCES_THRESHOLD = 100
// =====================================================

// Configuración para Facturas (tab ficha de cliente)
// =====================================================
// Si el número de contratos del cliente es >= este umbral, el filtro por defecto
// será 3 meses; si es menor, será 12 meses
const INVOICES_CONTRACTS_THRESHOLD = 20
// =====================================================

export const envConfig = {
  subscriptions: {
    front: REACT_APP_FRONT_SUBSCRIPTION
  },
  environment: REACT_APP_ENV,
  prefixes: {
    frontServices: REACT_APP_PREFIX_ENVIRONMENT_FRONT_SERVICES
  },
  publicUrl: PUBLIC_URL,
  invoiceCycleConfig: {
    maxQueryItems: INVOICE_CYCLE_MAX_QUERY_ITEMS,
    pollingDelay: INVOICE_CYCLE_POLLING_DELAY,
    pollingMaxRetries: INVOICE_CYCLE_POLLING_MAX_RETRIES
  },
  priceComponentInstancesConfig: {
    threshold: PRICE_COMPONENT_INSTANCES_THRESHOLD
  },
  invoicesConfig: {
    contractsThreshold: INVOICES_CONTRACTS_THRESHOLD
  },
  kpiConfig: {
    maxDisplayValue: 10_000
  }
  // TO DO
  // apiManagementHost: process.env.REACT_APP_API_MANAGEMENT_HOST ?? 'https://default-api.com',
  // prefixStorageManagement: process.env.REACT_APP_PREFIX_ENVIRONMENT_STORAGE_MANAGEMENT ?? '',
  // auth: {
  //   clientId: process.env.REACT_APP_AUTH_CLIENT_ID ?? '',
  //   tenantName: process.env.REACT_APP_AUTH_TENANT_NAME ?? '',
  //   cacheLocation: process.env.REACT_APP_AUTH_CACHE_LOCATION ?? 'sessionStorage',
  //   scopes: process.env.REACT_APP_AUTH_SCOPES ?? 'openid',
  //   signInPolicy: process.env.REACT_APP_AUTH_SIGNIN_POLICY ?? ''
  // },
  // adoApi: {
  //   projectId: process.env.REACT_APP_ADO_API_PROJECT_ID ?? '',
  //   wikiId: process.env.REACT_APP_ADO_API_WIKI_ID ?? '',
  //   orgUrl: process.env.REACT_APP_ADO_API_ORG_URL ?? '',
  //   personalAccessToken: process.env.REACT_APP_ADO_API_PERSONAL_ACCESS_TOKEN ?? ''
  // },
  // storageAccount: process.env.REACT_APP_STORAGE_ACCOUNT ?? '',
}
